import React from "react";
import { useLocation } from "react-router-dom";
import "./common.css";

/**
 * PrimaryButton: Renders a <button> if no href, or <a> if href is provided.
 */
export function PrimaryButton({ children, href, className = "", type = "button", disabled = false, ...rest }) {
  const { pathname, search } = useLocation();

  if (href) {
    const finalHref =
      typeof href === "string" && href.startsWith("#")
        ? `${pathname}${search}${href}`
        : href;
    return (
      <a
        href={finalHref}
        className={`primary-btn ${className}`}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={`primary-btn ${className}`}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}

/**
 * SecondaryButton: Renders a <button> if no href, or <a> if href is provided.
 */
export function SecondaryButton({ children, href, className = "", type = "button", disabled = false, ...rest }) {
  const { pathname, search } = useLocation();

  if (href) {
    const finalHref =
      typeof href === "string" && href.startsWith("#")
        ? `${pathname}${search}${href}`
        : href;
    return (
      <a
        href={finalHref}
        className={`secondary-btn ${className}`}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={`secondary-btn ${className}`}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}
